<div id="modal-decision">
    <div class="modal-header border-0">
        <button type="button" class="btn-close" aria-label="Close" data-dismiss="modal-decision" (click)="cerrar('')"></button>
    </div>
    <div class="modal-body text-center">
        <div class="icons">
            <div class="swal2-icon swal2-success swal2-animate-success-icon">
                <div class="swal2-success-circular-line-left"></div>
                <span class="swal2-success-line-tip swal2-animate-success-line-tip"></span>
                <span class="swal2-success-line-long swal2-animate-success-line-long"></span>
                <div class="swal2-success-ring"></div>
                <div class="swal2-success-fix"></div>
                <div class="swal2-success-circular-line-right"></div>
            </div>
        </div>
        <h3>{{mensaje}}</h3>
    </div>

    <div class="modal-footer border-0">
        <button id="neoBtnAccept" type="button" class="btn btn-primary" (click)="cerrar('aceptar')">Aceptar</button>
    </div>
</div>
